export default {
  top_projects: "热门 项目".toUpperCase(),
  show_more: "展开更多".toUpperCase(),
};
